import cart from './slices/cart';
import formLang from './slices/formLang';
import menu from './slices/menu';
import order from './slices/order';
import category from './slices/category';
import brand from './slices/brand';
import banner from './slices/banner';
import product from './slices/product';
import orders from './slices/orders';
import currency from './slices/currency';
import discount from './slices/discount';
import blog from './slices/blog';
import notification from './slices/notification';
import user from './slices/user';
import extraGroup from './slices/extraGroup';
import extraValue from './slices/extraValue';
import payment from './slices/payment';
import invite from './slices/invite';
import faq from './slices/faq';
import client from './slices/client';
import auth from './slices/auth';
import productReview from './slices/productReview';
import orderReview from './slices/orderReview';
import globalSettings from './slices/globalSettings';
import chat from './slices/chat';
import statisticsCount from './slices/statistics/count';
import statisticsSum from './slices/statistics/sum';
import topCustomers from './slices/statistics/topCustomers';
import topProducts from './slices/statistics/topProducts';
import orderCounts from './slices/statistics/orderCounts';
import orderSales from './slices/statistics/orderSales';
import theme from './slices/theme';
import point from './slices/point';
import languages from './slices/languages';
import orderStatus from './slices/orderStatus';
import subscriber from './slices/subscriber';
import messageSubscriber from './slices/messegeSubscriber';
import storeis from './slices/storeis';
import workingDays from './slices/shopWorkingDays';
import closeDates from './slices/shopClosedDays';
import refund from './slices/refund';
import productReport from './slices/report/products';
import categoryReport from './slices/report/categories';
import orderReport from './slices/report/order';
import stockReport from './slices/report/stock';
import revenueReport from './slices/report/revenue';
import overviewReport from './slices/report/overview';
import extrasReport from './slices/report/extras';
import branch from './slices/branch';
import addons from './slices/addons';
import bonusList from './slices/bonus-list';
import referralList from './slices/referral-list';
import coupons from './slices/coupon';
import todo from './slices/todo';
import box from './slices/box';
import recipeCategory from './slices/recipe-category';
import menuCategory from './slices/menuCategory';
import landingPage from './slices/landing-page';
import propertyGroup from './slices/propertyGroup';
import propertyValue from './slices/propertyValue';
import gallery from './slices/gallery';
import repair from './slices/repair';
import adminMessages from './slices/adminMessages';
import specialOffers from './slices/specialOffers';
import tracking from './slices/tracking';
import appShop from './slices/appShop';
import myShop from './slices/myShop';
import dashboardSummary from './slices/dashboardSummary';
import period from './slices/period';

const rootReducer = {
  appShop,
  myShop,
  dashboardSummary,
  menuCategory,
  coupons,
  bonusList,
  referralList,
  addons,
  branch,
  refund,
  closeDates,
  workingDays,
  storeis,
  messageSubscriber,
  subscriber,
  orderStatus,
  languages,
  cart,
  menu,
  formLang,
  order,
  category,
  brand,
  banner,
  product,
  orders,
  currency,
  discount,
  blog,
  notification,
  user,
  extraGroup,
  extraValue,
  payment,
  invite,
  faq,
  client,
  auth,
  productReview,
  orderReview,
  globalSettings,
  chat,
  statisticsCount,
  statisticsSum,
  topProducts,
  topCustomers,
  orderCounts,
  orderSales,
  theme,
  point,
  productReport,
  categoryReport,
  orderReport,
  stockReport,
  revenueReport,
  overviewReport,
  extrasReport,
  todo,
  box,
  recipeCategory,
  landingPage,
  propertyGroup,
  propertyValue,
  gallery,
  repair,
  adminMessages,
  specialOffers,
  tracking,
  period,
};

export default rootReducer;
